import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { Interface } from "../types";
import { isTemplateInterfaceProjectId } from "../utils";

export const fetchInterfaceProjectAtomFamily_SUSPENDS = atomFamily(
  (interfaceProjectId: string | undefined) => {
    const baseAtom = atom(async () => {
      if (!interfaceProjectId) {
        return;
      }
      const isTemplateInterface =
        isTemplateInterfaceProjectId(interfaceProjectId);

      if (isTemplateInterface) {
        // Because we don't want to fetch with template asset id and get a 404 Not Found error
        return;
      }

      try {
        const res = await fetch(
          `/api/canvas/v1/projects/${interfaceProjectId}/`,
        );

        if (res.ok) {
          const json = await res.json();
          return json as Interface;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    });

    baseAtom.debugLabel = `fetchInterfaceProjectAtomFamily_SUSPENDS(${interfaceProjectId})`;
    return baseAtom;
  },
);
